/*

These are the options you can pass in to DragManager.start:

    cursor: (String) Sets the global cursor for the duration of the drag
    gesture.

    onConsummate(mouseMoveEvent): Will be called once the user has moved the
    mouse 3 pixels from the initial mouse down location.

    onMove(mouseMoveEvent): Will be called repeatedly, every time the mouse
    moves after the drag has been consummated.

    onDrop(mouseUpEvent): Will be called once the user releases the object being
    dragged.

    onCancel(mouseUpEvent): Will be called if the user releases the object
    without ever consummating the drag.

*/

export default class DragManager {
  constructor() {
    this._onMouseMove = this._onMouseMove.bind(this);
    this._onMouseUp = this._onMouseUp.bind(this);
    this.drag = null;
    window.addEventListener("mousemove", this._onMouseMove);
    window.addEventListener("mouseup", this._onMouseUp);
  }

  start(mouseDownEvent, spec) {
    this.drag = new Drag(mouseDownEvent, spec);
  }

  _onMouseMove(mouseMoveEvent) {
    if (!this.drag) { return; }
    if (!this.drag.consummated) {
      // Check if we should consummate.
      const dx = mouseMoveEvent.clientX - this.drag.originalX;
      const dy = mouseMoveEvent.clientY - this.drag.originalY;
      const d  = Math.max(Math.abs(dx), Math.abs(dy));
      if (d > 3) {
        this._consummate(mouseMoveEvent);
      }
    } else if (typeof this.drag.onMove === 'function') {
      this.drag.onMove(mouseMoveEvent)
    }
  }

  _onMouseUp(mouseUpEvent) {
    if (!this.drag) { return; }
    if (this.drag.consummated) {
      if (typeof this.drag.onDrop === 'function') {
        this.drag.onDrop(mouseUpEvent);
      }
    } else {
      if (typeof this.drag.onCancel === 'function') {
        this.drag.onCancel(mouseUpEvent);
      }
    }
    if (typeof this.drag.onUp === 'function') {
      this.drag.onUp(mouseUpEvent);
    }
    this.drag = null;
  }

  _consummate(mouseMoveEvent) {
    this.drag.consummated = true;
    if (typeof this.drag.onConsummate === 'function') {
      this.drag.onConsummate(mouseMoveEvent);
    }
  }
};


class Drag {
  constructor(mouseDownEvent, spec) {
    Object.assign(this, spec);
    this.originalX = mouseDownEvent.clientX;
    this.originalY = mouseDownEvent.clientY;
    if (this.consummated == null) { this.consummated = false; }
  }
}



// WEBPACK FOOTER //
// ./src/view/DragManager.js